import React, { useState } from "react";
import List from "@mui/material/List";
import SideBarDropdown from "./SideBarDropdown";
import { SideBarDropdownData } from "../../../constansts/LocalData";
import { ROLES } from "../../../constansts/Roles";
import Logo from "../../../assets/images/delta-tieup-logo.png";
import SidebarFooterArt from "../../../assets/images/sidebar-footer.svg";
import { useSelector } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";

const getInitials = (text = "") => {
   const parts = text.trim().split(/\s+/).filter(Boolean);
   if (!parts.length) return "U";
   if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
   return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};

const CommonSideBar = () => {
   const navigate = useNavigate();
   const location = useLocation();
   const user = useSelector((state) => state?.auth?.user?.data?.user);
   const role_id = user?.role_id;
   const role_name = user?.role_name;
   const displayName =
      role_id === ROLES.driver ? "Driver" : role_name || user?.name || "User";
   const secondaryLabel =
      role_id === ROLES.corporateAdmin
         ? "Super Admin"
         : role_id === ROLES.driver
           ? "Driver"
           : "";
   const [activeMenu, setActiveMenu] = useState("");
   const isDashboardActive =
      location.pathname === "/dashboard" || location.pathname === "/";

   return (
      <aside className="main-sidebar sidebar-dark-primary elevation-4 oil-sidebar">
         <Link to="/dashboard" className="brand-link oil-sidebar__brand">
            <img src={Logo} alt="Delta Tieup" className="oil-sidebar__logo" />
            <span className="brand-text oil-sidebar__brand-text">Delta Tieup</span>
         </Link>

         <div className="sidebar oil-sidebar__body">
            <div className="oil-sidebar__user">
               <div className="oil-sidebar__avatar" aria-hidden="true">
                  {getInitials(displayName)}
               </div>
               <div className="oil-sidebar__user-meta">
                  <span className="oil-sidebar__user-name">{displayName}</span>
                  {secondaryLabel && (
                     <span className="oil-sidebar__user-role">{secondaryLabel}</span>
                  )}
               </div>
            </div>

            <nav className="oil-sidebar__nav mt-2">
               <ul
                  className="nav nav-pills nav-sidebar flex-column"
                  data-widget="treeview"
                  role="menu"
                  data-accordion="false"
               >
                  {role_id !== ROLES.driver && (
                     <li
                        className={`nav-item oil-sidebar__item ${
                           isDashboardActive ? "active" : ""
                        }`}
                     >
                        <a
                           className={`nav-link oil-sidebar__link ${
                              isDashboardActive ? "active" : ""
                           }`}
                           onClick={() => navigate("/dashboard")}
                        >
                           <i className="nav-icon fas fa-home" />
                           <p>Dashboard</p>
                        </a>
                     </li>
                  )}

                  <List className="oil-sidebar__menu-list" disablePadding>
                     {SideBarDropdownData.filter((item) =>
                        item.roles.includes(role_id)
                     ).map((item, index) => (
                        <SideBarDropdown
                           label={item.menuName}
                           url={item.url}
                           icon={item.icon}
                           dropdownList={item.dropdownList}
                           isOpen={activeMenu === item.menuName}
                           onToggle={() =>
                              setActiveMenu((prev) =>
                                 prev === item.menuName ? "" : item.menuName
                              )
                           }
                           key={index.toString()}
                        />
                     ))}
                  </List>
               </ul>
            </nav>

            <div className="oil-sidebar__footer" aria-hidden="true">
               <img src={SidebarFooterArt} alt="" className="oil-sidebar__footer-art" />
            </div>
         </div>
      </aside>
   );
};

export default CommonSideBar;
